import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=00821d28"
import script from "./SideMenu.ts?vue&type=script&lang=ts&external"
export * from "./SideMenu.ts?vue&type=script&lang=ts&external"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=00821d28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports